<template>
    <div class="space-group-row-container">
        <SpaceGroupRow @moveUp="$emit('moveUp')" @moveDown="$emit('moveDown')"
                       :hide="hide" @toggleVisibility="hide = !hide"
                       :hide-copy="true" @onDelete="$emit('onDelete')" :text="space.name"
                       :bold="true" :styles="{marginTop: '5px'}"></SpaceGroupRow>
        <div v-if="!hide">
            <InteractionRow v-for="(inter,index) in interactions" v-bind:key="space.id + '' + inter.id + '' + index"
                            :name="inter.name" :actions="inter.action"
                            :technical-name="space.technical_name + inter.technical_name"
                            :description="inter.description" :widths="widths">
            </InteractionRow>
            <div class="module-container" v-for="module in space.modules" v-bind:key="module.id">
                <SpaceGroupRow :hide-move="true" :hide-delete="true" :hide-copy="true" :text="module.name"
                               :hide="module.hide" :hide-toggle-icon="true"
                               :styles="{padding: '0.7rem 1.25rem'}"></SpaceGroupRow>
                <InteractionRow v-for="(inter,index) in module.filteredInteractions"
                                v-bind:key="module.id + '' + inter.id  + '' + index"
                                :name="inter.name" :actions="inter.action"
                                :technical-name="technicalName + '_' + module.technical_name + inter.technical_name"
                                :description="inter.description" :widths="widths">
                </InteractionRow>
            </div>
        </div>
        <!--<AdaButton icon="icon-add" @click="emitOpenDialog(space.id)" type="fullWidthButton tracking"
                   title="TRACKING HINZUFÜGEN"></AdaButton>-->
    </div>
</template>

<script>

    import InteractionRow from "../spaces/InteractionRow";
    import SpaceGroupRow from "../spaces/SpaceGroupRow";

    export default {
        components: {
            InteractionRow,
            SpaceGroupRow
        },
        props: {
            space: {
                required: true
            },
            technicalName: {
                required: true
            },
            interactions: {
                required: true
            },
            widths:{
                required: false,
                type: Array
            }
        },
        data: function () {
            return {
                hide: false,
            }
        },
        name: "TrackingListSpaceElement",
        mounted() {
            this.hide = this.space.hide;
        },
        methods: {}
    }
</script>

<style lang="scss" scoped>
    .accordion-item-trigger-icon {
        width: 13px;
        height: 13px;
    }

</style>